import { ChatAPI, isChatIframed } from '@guuru/chat-web';
import { client } from '@guuru/graphql-web';
import smartForm from '@guuru/smartform-web';
import CHAT_TRANSFER_BY_EMAIL from './mutations/TransferByEmail';
import CHAT_TRANSFER from './mutations/TransferChat';

export default async function (partnerId, chatId, { handover, targetId }) {
  const isDelegated =
    isChatIframed() &&
    (await smartForm.showClientContactForm(partnerId, chatId));

  const {
    data: { transferChat, transferByEmail },
  } = await client.mutate({
    mutation: handover ? CHAT_TRANSFER_BY_EMAIL : CHAT_TRANSFER,
    variables: { chatId, targetId },
  });

  const status = transferChat?.status ?? transferByEmail?.status;

  if (isDelegated) {
    ChatAPI.storeReset(partnerId);
  }

  return { chatId, status };
}
